
const firebaseConfig = {
    apiKey: "AIzaSyAZ6-0GzDuLFlVadvM9EEh8hBmvykqPNq0",
    authDomain: "cocktaildb-2a7d2.firebaseapp.com",
    projectId: "cocktaildb-2a7d2",
    storageBucket: "cocktaildb-2a7d2.appspot.com",
    messagingSenderId: "760930574999",
    appId: "1:760930574999:web:ac7660dd40e19228e07fd2"
  };

  export default firebaseConfig